export default function CMathFunctions() {
  return <h2>C Math Functions</h2>;
}
